import { IPreviewStatsReportPreviewWidget, } from 'atlas-shared';
import { IStatsReportPreviewWidgetStore, StatsReportPreviewWidgetActions, TStatsReportPreviewWidgetActionTypes, } from '@Store';

export const StatsReportPreviewWidgetReducer = (state: IStatsReportPreviewWidgetStore = {
  loaded: false,
  loading: false,
  stats_report_preview_widgets: [],
  dict: {},
}, action: TStatsReportPreviewWidgetActionTypes): IStatsReportPreviewWidgetStore => {
  switch (action.type) {
  case StatsReportPreviewWidgetActions.LOADING:
    return { ...state, loading: true, };
  case StatsReportPreviewWidgetActions.SET_STATE:
    const dict: IStatsReportPreviewWidgetStore['dict'] = {};

    action.payload.forEach((stats_report_preview_widget: IPreviewStatsReportPreviewWidget) => dict[stats_report_preview_widget.id] = stats_report_preview_widget);

    return { ...state, loaded: true, loading: false, stats_report_preview_widgets: action.payload, dict, };
  case StatsReportPreviewWidgetActions.ADD_STATE:
    return { ...state, stats_report_preview_widgets: [...state.stats_report_preview_widgets, action.payload, ], dict: { ...state.dict, [action.payload.id]: action.payload, }, };
  case StatsReportPreviewWidgetActions.REMOVE_STATE: {

    const { [action.payload]: _deleted, ...dict } = state.dict;

    return { ...state, stats_report_preview_widgets: state.stats_report_preview_widgets.filter((item: IPreviewStatsReportPreviewWidget) => item.id !== action.payload), dict, };
  }
  case StatsReportPreviewWidgetActions.UPDATE_STATE:
    const stats_report_preview_widgets = [...state.stats_report_preview_widgets, ];
    const index = state.stats_report_preview_widgets.findIndex((stats_report_preview_widget: IPreviewStatsReportPreviewWidget) => stats_report_preview_widget.id === action.payload.id);

    if (!~index)
      stats_report_preview_widgets.push(action.payload);
    else
      stats_report_preview_widgets[index] = action.payload;

    return { ...state, stats_report_preview_widgets, dict: { ...state.dict, [action.payload.id]: action.payload, }, };
  default:
    return state;
  }
};
